import { CustomConnectorDto, ConnectorFlowDTO, ConnectorInstanceSafeDTO } from '@/models/connectors';
import { DataSource, Header, SourceConnectorPreviewRecord } from '@/models/dataSource';

export type SourceConnectorWizardRouteState = {
  connectorId: string;
  fromCatalogManage?: boolean;
};

export type SourceConnectorWizardData = {
  name: string;
  connector?: CustomConnectorDto;
  connectorInstance?: ConnectorInstanceSafeDTO;
  flow?: ConnectorFlowDTO;
  params: Record<string, unknown>;
  previewRecords: SourceConnectorPreviewRecord[];
  mappingHeaders: string[];
  mappings: Header[];
  createdDataSource?: DataSource;
};

export const initialSourceConnectorWizardData = (): SourceConnectorWizardData => ({
  name: '',
  params: {},
  previewRecords: [],
  mappingHeaders: [],
  mappings: [],
});
